import React from 'react';
import { bool, func } from 'prop-types';
import TableCell, { ExpandCell } from '../cell';
import Row from './row';

const ExpandableRow = ({
  expanded,
  expandable,
  toggleExpand,
  children,
  ...props
}) => (
  <Row
    {...props}
  >
    {expandable ?
      <ExpandCell expanded={expanded} toggleExpand={toggleExpand} /> :
      <TableCell className="mdl-data-table__cell--collapse-btn">&nbsp;</TableCell>}
    {children}
  </Row>
);

ExpandableRow.propTypes = {
  expanded: bool,
  expandable: bool,
  toggleExpand: func,
};

ExpandableRow.defaultProps = {
  expanded: false,
  expandable: true,
  toggleExpand: undefined,
};

export default ExpandableRow;
